import { WithMongooseProps } from '@runelab/odin-common'

// Parsing lifecycle of a bot-chat attachment (server-side text extraction).
export enum ChatAttachmentStatusEnum {
  TRANSLATING = 'translating',
  READY = 'ready',
  FAILED = 'failed',
}

export type ChatAttachment = WithMongooseProps<{
  chatId: string
  tenantId?: string
  name: string
  url: string
  mimeType: string
  sizeBytes: number
  status: ChatAttachmentStatusEnum
}>
